<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectedMonth"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Mês
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedMonth: this.value,
      options: [
        { value: '01', text: 'Janeiro' },
        { value: '02', text: 'Fevereiro' },
        { value: '03', text: 'Março' },
        { value: '04', text: 'Abril' },
        { value: '05', text: 'Maio' },
        { value: '06', text: 'Junho' },
        { value: '07', text: 'Julho' },
        { value: '08', text: 'Agosto' },
        { value: '09', text: 'Setembro' },
        { value: '10', text: 'Outubro' },
        { value: '11', text: 'Novembro' },
        { value: '12', text: 'Dezembro' },
      ],
    };
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selectedMonth);
    },
  },
};
</script>
